export const dimensions = {
  appBarHeight: 64,
  sideMenuCollapsedWidth: 77,
} as const;
